module.exports = __webpack_public_path__ + "static/media/BackData.a1af968d.png";